module.exports = __webpack_public_path__ + "static/media/woman.9b2d1f56.png";